import { type ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

/**
 * Lightweight route-scoped enter animation.
 *
 * On every pathname change, mount the children under a new key and play a
 * fade-up keyframe via class. Transform-only — cheap on cheap Android.
 *
 * We deliberately do NOT use the View Transitions API for the route switch
 * itself because React Router 7 transitions the DOM before VT can capture the
 * old frame. The CSS keyframe approach is portable and predictable.
 */
export function PageTransition({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const [renderedPath, setRenderedPath] = useState(pathname);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (renderedPath !== pathname) {
      setRenderedPath(pathname);
      setTick((t) => t + 1);
    }
  }, [pathname, renderedPath]);

  return (
    <div key={tick} className="fade-up motion-page">
      {children}
    </div>
  );
}
